import styled from 'styled-components';
const sizes = {
  small: '0.625rem',
  normal: '0.75rem',
  large: '1rem'
};
const getColor = ({
  color,
  theme
}) => theme.palette[color] || color;
const getText = ({
  'data-color': color,
  theme
}) => getColor({
  color,
  theme
}) || 'inherit';
const getBg = ({
  'data-background': color,
  theme
}) => getColor({
  color,
  theme
}) || 'transparent';
const getBorderColor = ({
  'data-border': color,
  theme
}) => getColor({
  color,
  theme
}) || 'transparent';
const getSize = ({
  'data-size': size
}) => sizes[size] || size;

// eslint-disable-next-line import/prefer-default-export
export const BadgeContainer = styled.span`
  display: ${({
  inline
}) => inline ? 'inline' : 'inline-block'};
  line-height: ${({
  inline
}) => inline ? 'inherit' : '1'};
  border-radius: ${({
  theme
}) => theme.smallBorderRadius};
  color: ${getText};
  font-size: ${getSize};
  font-weight: 500;
  text-transform: uppercase;
  background: ${getBg};
  border-color: ${getBorderColor};
  border-width: ${({
  'data-outline': outline
}) => outline ? '1px' : '0'};
  border-style: solid;
  padding: ${({
  'data-outline': outline
}) => outline ? 'calc(0.3125rem - 1px)' : '0.3125rem'} 0.75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  cursor: default;
`;
//# sourceMappingURL=styles.js.map